import * as i0 from '@angular/core';
import { inject, LOCALE_ID, signal, isDevMode, Injectable, computed, effect } from '@angular/core';
import { UserSettingsLanguageService } from '@rxap/ngx-user';
import { ConfigService } from '@rxap/config';

class I18nService {
    constructor() {
        this.localId = inject(LOCALE_ID);
        this.userSettingsLanguageService = inject(UserSettingsLanguageService);
        this.currentLanguage = signal(this.localId.replace(/-[A-Z]+$/, ''));
    }
    async setLanguage(language) {
        await this.userSettingsLanguageService.setLanguage(language);
        if (!isDevMode()) {
            this.redirect(language);
        }
        if (typeof this.currentLanguage['set'] === 'function') {
            this.currentLanguage.set(language);
        }
    }
    redirect(next, current = this.currentLanguage()) {
        if (current === next) {
            console.warn('[I18nService] redirect not required - language unchanged');
            return;
        }
        const redirectUrl = location.origin +
            location.pathname.replace(new RegExp(`^/${current}`), `/${next}`) +
            location.search;
        console.log('[I18nService] redirect to: ' + redirectUrl);
        location.replace(redirectUrl);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: I18nService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: I18nService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: I18nService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

function LanguageInterceptor(request, next) {
    const localId = inject(LOCALE_ID, { optional: true });
    if (localId) {
        request = request.clone({
            headers: request.headers.set('Accept-Language', localId),
        });
    }
    return next(request);
}

class LanguageSelectorService {
    constructor() {
        this.config = inject(ConfigService);
        this.i18nService = inject(I18nService);
        this.languages = signal(this.config.get('i18n.languages', {}));
        this.defaultLanguage = signal(this.config.get('i18n.defaultLanguage', Object.keys(this.languages())[0] ?? 'en'));
        this.selectedLanguage = signal(this.i18nService.currentLanguage());
        this.hasLanguages = computed(() => Object.keys(this.languages()).length > 1);
        effect(() => {
            const currentLanguage = this.i18nService.currentLanguage();
            this.selectedLanguage.set(currentLanguage);
        }, { allowSignalWrites: true });
    }
    async setLanguage(language) {
        if (language !== this.i18nService.currentLanguage()) {
            await this.i18nService.setLanguage(language);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: LanguageSelectorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: LanguageSelectorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.1", ngImport: i0, type: LanguageSelectorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

// region 
// endregion

/**
 * Generated bundle index. Do not edit.
 */

export { I18nService, LanguageInterceptor, LanguageSelectorService };
